// TableSkeleton Component
import { Box, Skeleton } from '@mui/material';

interface TableSkeletonProps {
  rows?: number;
  columns?: number;
}

// Pre-computed array helper
const createArray = (length: number) => Array.from({ length }, (_, i) => i);

export const TableSkeleton = ({ rows = 5, columns = 4 }: TableSkeletonProps) => {
  const rowArray = createArray(rows);
  const columnArray = createArray(columns);

  return (
    <Box
      sx={{
        borderRadius: 2,
        bgcolor: 'background.paper',
        border: 1,
        borderColor: 'divider',
        overflow: 'hidden',
      }}
    >
      {/* Header */}
      <Box
        display="grid"
        gridTemplateColumns={`repeat(${columns}, 1fr)`}
        gap={2}
        p={2}
        bgcolor="action.hover"
      >
        {columnArray.map((index) => (
          <Skeleton key={index} variant="text" height={24} />
        ))}
      </Box>

      {/* Rows */}
      {rowArray.map((rowIndex) => (
        <Box
          key={rowIndex}
          display="grid"
          gridTemplateColumns={`repeat(${columns}, 1fr)`}
          gap={2}
          p={2}
          borderTop={1}
          borderColor="divider"
        >
          {columnArray.map((colIndex) => (
            <Skeleton key={colIndex} variant="text" height={20} />
          ))}
        </Box>
      ))}
    </Box>
  );
};

export default TableSkeleton;
